import {withRouter} from "react-router";
import React, {Fragment} from "react";
import {Card, Input} from "reactstrap";
import UserSessionService from "../../services/UserSessionService";
import {formatTransactionCardDate} from "../../utils/DateFormatter";
import {Image} from "react-bootstrap";

class ConversationCard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            userId: UserSessionService.getUser().user.id
        }
    }

    onSelectConversation(conversation) {
        let url = '/chat/' + conversation.id
        this.props.history.push(url);
    }

    render() {
        let unRead = false;
        this.props.conversation.participants.forEach(participant => {
            if (participant.hasUnreadMessages && participant.userId === this.state.userId) {
                unRead = true;
            }
        })


        let text = '*No Messages*';
        if(this.props.conversation.messages.length > 0){
            text = this.props.conversation.messages[this.props.conversation.messages.length - 1].type !== 'FILE'
                ? this.props.conversation.messages[this.props.conversation.messages.length - 1].data
                : '*image*'
        }

        return <Fragment key={this.props.conversation.id}>
            <div style={{boxShadow: "rgb(136, 136, 136) 1px 1px 5px", borderRadius: "20px"}}>
                <Card style={{borderRadius: "20px"}}>
                    <div className={"card-body"} onClick={() => {
                        this.onSelectConversation(this.props.conversation)
                    }} style={{padding: "0.75rem"}}>
                        {
                            unRead && this.renderUnreadDisplay()
                        }

                        <div style={{display: "flex", flexDirection: "row", maxWidth: "100%"}}>
                            <div style={{marginBottom: "auto", marginTop: "auto"}}>
                                <Image
                                    src={"https://sfx-public-bucket.s3.eu-west-1.amazonaws.com/agent-category-images/ROCKSTAR_face.png"}
                                    height={"30px"} width={"30px"}/>
                            </div>
                            <div style={{
                                paddingLeft: "10px", maxWidth: "94%"}}
                            >
                                <div style={{
                                    fontWeight: 'bold',
                                    display: 'box',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    color: "#2ba6ff"
                                }}
                                >
                                    {this.props.conversation.name}
                                </div>

                                {
                                    this.props.conversation.messages.length > 0 &&
                                    <div style={{fontSize: '8pt', color: "#686868"}}>
                                        {formatTransactionCardDate(this.props.conversation.messages[this.props.conversation.messages.length - 1].dateCreated)}
                                    </div>
                                }
                            </div>
                        </div>
                        <Input type={'text'}
                               value={text}
                               rows={1}
                               onChange={() => {}}
                               style={{
                                   background: 'none',
                                   color: 'default',
                                   fontSize: '10pt',
                                   padding: 0,
                                   border: "none",
                                   textOverflow: "ellipsis"
                               }}
                        />

                    </div>
                </Card>
            </div>
            <br/>
        </Fragment>
    }

    renderUnreadDisplay() {
        return <Fragment>
            <div style={{
                padding: 0,
                borderRadius: 50,
                maxWidth: 10,
                maxHeight: 10,
                minWidth: 10,
                minHeight: 10,
                textAlign: 'center',
                float: 'right'
            }}
                 className={"btn-primary"}
            />
        </Fragment>
    }
}

export default withRouter(ConversationCard)